import namespace from './namespace';

export default {
	[namespace.state.CONFIG]: {contextPath: ''},
	[namespace.state.COOKIE_STORE]: {},
	[namespace.state.NOTIFICATIONS]: {},
	[namespace.state.NOTIFICATIONS_LISTENERS]: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/app/state.js